import { apiConfig } from '@/services/api-config';
import { getUserGroup } from '@/utils';
import constants from '@/config/constants';

export default async function (id: string) {
  const { roles: { produtor, frigorifico, admin } } = constants;
  const userLogged = sessionStorage.getItem('userLogged');
  const userGroup = getUserGroup() || admin;

  let tokenKey = '';
  let userCode = '';

  if (userLogged) {
    tokenKey = JSON.parse(userLogged).company.stKey;

    if (userGroup === produtor) userCode = JSON.parse(userLogged).stDocument;
    else if (userGroup === frigorifico) userCode = JSON.parse(userLogged).idUser;
  }

  return apiConfig
    .get(`api/territory/get-by-id?id=${id}&role=${userGroup.toUpperCase()}&userCode=${userCode}&tokenKey=${tokenKey}`)
    .then((response) => response.data)
    .catch(() => []);
}
